export default "__VITE_PUBLIC_ASSET__898aa338__"